/** @format */

import { END_POINT, headersFormData } from "utils";
import { deleteRequest, getRequest, postRequest } from "./axios";
import { IdForm, FormProjectUpdate, FormProjectStore, FormProjectAttachment } from "types";
import { toFormData } from "axios";

export const projectService = {
  onGetList: async (page = 1) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}?page=${page}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  attachment: async (payload: FormProjectAttachment) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.id}/attachment`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  show: async (code) => {
    try {
      const rs = await getRequest(`${END_POINT.PROJECTS.LIST}/${code}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  store: async (payload: FormProjectStore) => {
    console.log("🚀 ~ payload:", payload)
    // return;
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}`, toFormData(payload), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  update: async (payload: FormProjectUpdate) => {
    try {
      const rs = await postRequest(`${END_POINT.PROJECTS.LIST}/${payload.id}`, toFormData({ ...payload, '_method': 'PATCH' }), {
        headers: headersFormData,
      });
      return rs.data;
    } catch (error) {
      return null;
    }
  },
  destroy: async (payload: IdForm) => {
    try {
      const rs = await deleteRequest(`${END_POINT.PROJECTS.LIST}/${payload.id}`);
      return rs.data;
    } catch (error) {
      return null;
    }
  },
};

